<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import { reportChefIssue } from '@/graph/mutations/issues'

import chefReportReasons from '@/assets/chef-report-reasons'

export default {
  name: 'ReportChefView',
  mixins: [validationMixin],
  data: () => ({
    rules,
    items: chefReportReasons,

    form: {
      details: '',
      reason: null
    },
    submitting: false
  }),
  computed: {
    userId() {
      const slug = this.$route.params.slug.split('-')
      return slug[-1]
    }
  },
  methods: {
    // Go back
    goBack() {
      if (this.form.reason) return (this.form.reason = null)
      this.$router.go(-1)
    },

    submit() {
      if (this.submitting || this.$v.$invalid) return
      this.submitting = true

      const { slug } = this.$route.params
      const data = this.form

      reportChefIssue(this.userId, data)
        .then(() => {
          this.$router
            .replace({ name: 'ChefView', params: { slug } })
            .then(() => this.$toast('Sent. We’ll be in touch soon.'))
        })
        .finally(() => (this.submitting = false))
    }
  },
  validations: {
    form: {
      reason: { required },
      details: { required }
    }
  }
}
</script>

<template>
  <div>
    <!-- Toolbar -->
    <v-app-bar color="white" flat app>
      <v-btn icon @click="goBack">
        <v-icon color="black" size="18">$vuetify.icons.arrowBack</v-icon>
      </v-btn>
    </v-app-bar>

    <transition name="slide-up" appear>
      <!-- Report chef view page -->
      <div class="view-grid">
        <div class="content-top px-3">
          <div class="display-1 font-weight-bold mb-3 px-2">
            Report cook
          </div>

          <p class="body-2 mt-1 px-2">
            Choose the issue you had, and we'll get back to you as soon as we
            can.
          </p>

          <v-layout v-if="!form.reason" row wrap>
            <v-list class="flex-grow-1">
              <!-- Order issue -->
              <v-list-item :to="{ name: 'OrderIssueView' }" class="pl-4 pr-5">
                <v-list-item-icon class="mr-4 ml-2">
                  <v-icon color="secondary" size="17">
                    $vuetify.icons.receipt
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                    I had a problem with my order
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                class="pl-4 pr-5"
                @click="form.reason = item.reason"
              >
                <v-list-item-icon class="mr-4 ml-2">
                  <v-icon color="secondary" size="17" v-text="item.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-layout>

          <transition name="fade" appear>
            <form v-if="form.reason" class="px-2" @submit.prevent="submit()">
              <v-textarea
                v-model="form.details"
                :rules="[rules.required]"
                name="issue-details"
                label="Tell us all about it..."
                rows="1"
                auto-grow
              />
              <v-btn
                :loading="submitting"
                :disabled="$v.$invalid"
                type="submit"
                depressed
                rounded
                color="primary"
                class="mt-2 px-8 body-2"
              >
                Submit
              </v-btn>
            </form>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="sass" scoped>
.content-top
  margin-top: 56px

.receipt-title
  line-height: 20px
  h4
    line-height: 16px

.v-list-item
  font-size: 15px
  min-height: 30px
  padding: 0

.v-list-item__icon
  min-width: 17px
  display: flex
  justify-content: center
</style>
